import { StatColumn } from "@bridgesplit/ui";

import { useRaydiumContext } from "../RaydiumContext";
import { useRaydiumOpenPositionLtv } from "./util";
import { useHealthChangeStats } from "../../clmm";

export default function OpenPositionStats() {
    const { openPositionForm } = useRaydiumContext();
    const openPositionLtv = useRaydiumOpenPositionLtv();
    const stats = useHealthChangeStats(openPositionLtv);

    if (
        !openPositionForm.tickLower ||
        !openPositionForm.tickUpper ||
        !openPositionForm.tokenAAmount ||
        !openPositionForm.tokenBAmount ||
        openPositionForm.status === undefined
    )
        return null;

    return <StatColumn loading={openPositionLtv.isLoading} stats={stats} />;
}
